<h3 fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px" style="margin-bottom: 0">
  <span>
    <span *ngIf="!title"></span>
    <span *ngIf="title">{{ title }}</span>
    <span *ngIf="areaType">{{ areaType | areaText }}</span>
    <span *ngIf="id">(id:{{ id }})</span>
  </span>
  <div
    *ngIf="state"
    class="progress"
    [style.background-color]="state | requestStatusNameAndCss : 'css' : statusModule"
    style="padding: 0 1em; height: 40px">
    <div style="line-height: 40px">
      {{ state | requestStatusNameAndCss : 'name' : statusModule }}
    </div>
  </div>
</h3>
